<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="120px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="5.0景区名称">
            <!-- <el-select v-model="queryForm.five_company_id" :clearable="true" placeholder="请选择5.0景区">
              <el-option
                v-for="item in storeList"
                :key="item.storeId"
                :label="item.storeName"
                :value="item.storeId"
              >
              </el-option>
            </el-select> -->
            <custom-select
              v-model="queryForm.five_company_id"
              :options="storeList"
              label-key="storeName"
              value-key="storeId"
              placeholder="请选择"
            />
          </el-form-item>
          <el-form-item label="小程序景区名称">
            <el-input
              v-model="queryForm.name"
              placeholder="请输入小程序景区名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" type="success"  v-hasPermi="['Island:scenic:add']"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="景区编号"
          prop="id"
        />
        <el-table-column
          align="center"
          label="景区名称"
          prop="companyName"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="five_conpany_name"
          label="5.0景区名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
        >
          <template #default="{ row }">
            <p>{{ transTime(row.insert_time) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:scenic:edit']"
              @click="handleEdit(row)"
            >
              <span>编辑</span>
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:scenic:delete']"
              @click="handleDelete(row)"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    <el-dialog
      title="基本信息"
      :visible.sync="dialogVisible"
      width="20%"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        label-width="80px"
      >
        <el-form-item label="订单名称" prop="app_name">
          <el-input
            v-model="dialogForm.app_name"
            placeholder="请输入订单名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单电台" prop="org_id">
          <el-select v-model="dialogForm.org_id" placeholder="请选择电台">
            <el-option
              v-for="item in businessList"
              :key="item.org_id"
              :label="item.name"
              :value="item.org_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单数量" prop="app_name">
          <el-input
            v-model="dialogForm.app_name"
            placeholder="请输入订单数量"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')"
              >确认下单</el-button
            >
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getList, getStoreList } from "@/api/order"
import { getCompanyList, delCompany, getZeusCompanyApi } from "@/api/radio"
import CustomSelect from "@/components/CustomSelect.vue"
import { transTime } from "@/utils/transTime"
import axios from 'axios'
export default {
  components: { CustomSelect },
  data() {
    return {
      transTime,
      businessList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        page: 1,
        pageSize: 10,
        five_company_id: null,
        name: '',
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      activeNames: "0",
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数

      tableData: [],
      storeList: [], // 5.0景区列表
      start: '',
      end: ''
    };
  },
  created() {
    this.getStoreList()
  },
  mounted() {
    console.log(111)
    axios.get('https://api.map.baidu.com/api_region_search/v1/?keyword=%E5%B1%B1%E4%B8%9C&sub_admin=2&ak=RCCevFHcerGActqKYlgcHYvAr7HiyCYn').then(res => {
      console.log(123, res)
    })
  },

  methods: {
    // 获取景区列表
    getStoreList() {
      getZeusCompanyApi()
        .then((res) => {
          if(res && res.data){
            this.storeList = res.data; // 全部的5.0景区数据
          }
          this.fetchData()
        })
        .catch((e) => {
          console.log(e);
        });
    },
    dateChange(val) {
      console.log(val)
      if(val){
        const [start, end] = val
        this.start = start
        this.end = end
      } else {
        this.start = ''
        this.end = ''
      }
    },
    
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData();
    },

    handleClose() {
      this.$nextTick(() => {
        this.dialogForm = {}; // 清空数据
        this.$refs["dialogForm"].clearValidate(); // 清空校验信息
      });
    },
    handleQuery() {
      // 查询
      this.queryForm.page = 1;
      const { timeRange } = this.queryForm
      this.fetchData()
    },
    handleAdd(){
      sessionStorage.setItem('scenicStore', JSON.stringify(this.storeList))
      this.$router.push({
        path:'/scenicList',
        query: {
          // storeList: JSON.stringify(this.storeList),
          type: 'add'
        }
      })
    },
    handleEdit(row){
      sessionStorage.setItem('scenic', JSON.stringify(row))
      sessionStorage.setItem('scenicStore', JSON.stringify(this.storeList))
      this.$router.push({
        path:'/scenicList',
        query: {
          // row: JSON.stringify(row),
          // storeList: JSON.stringify(this.storeList),
          type: 'edit'
        }
      })
    },
    handleDelete(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCompany({id: row.id}).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        })
      }).catch(() => {
      })
    },
    async fetchData() {
      // 拉取数据
      // 这里发请求
      let params = {
        start: this.start,
        end: this.end,
        five_company_id: this.queryForm.five_company_id, // 景区名称
        name: this.queryForm.name,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      await getCompanyList(params)
        .then((res) => {
          if (res && res.code) {
            let tableData = res.data.data_list
            this.total = res.data.total_record; // 总共数量
            tableData.forEach(item => {
              const store = this.storeList.find(s => s.storeId == item.five_company_id)
              if (store) {
                  item.five_conpany_name = store.storeName
              }
            })
            this.tableData = tableData
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitForm() {},
  },
};
</script>
<style lang="scss" scoped>
.tableCard {
  margin-top: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>